module.exports = __webpack_public_path__ + "static/media/pdc-logo.7bb4fe18.svg";